var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightAnimal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 105,
    viewBox: "0 0 233 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9791 30.1244L60.1201 39.0142L62.2104 40.9191L66.8733 29.9658L63.9791 30.1244Z",
    fill: "#940006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0759 30.1244L46.9349 39.0142L44.8445 40.9191L40.1816 29.9658L43.0759 30.1244Z",
    fill: "#940006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8711 45.8399L34.0715 52.6659L35.197 49.0148L26.9966 42.665L25.8711 45.8399Z",
    fill: "#940006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5759 45.8399L71.3755 52.6659L70.25 49.0148L78.4504 42.665L79.5759 45.8399Z",
    fill: "#940006"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1461 49.5934C26.6451 49.5934 30.2922 46.0837 30.2922 41.7542C30.2922 37.4248 26.6451 33.915 22.1461 33.915C17.6471 33.915 14 37.4248 14 41.7542C14 46.0837 17.6471 49.5934 22.1461 49.5934Z",
    fill: "#FFBF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1461 48.7935C26.6451 48.7935 30.2922 45.4628 30.2922 41.3543C30.2922 37.2457 26.6451 33.915 22.1461 33.915C17.6471 33.915 14 37.2457 14 41.3543C14 45.4628 17.6471 48.7935 22.1461 48.7935Z",
    fill: "#940006"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7388 47.0511C26.0128 47.0511 29.4776 44.1105 29.4776 40.4831C29.4776 36.8556 26.0128 33.915 21.7388 33.915C17.4648 33.915 14 36.8556 14 40.4831C14 44.1105 17.4648 47.0511 21.7388 47.0511Z",
    fill: "url(#paint0_radial_2_423)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.7389 47.051C26.013 47.051 29.4778 44.1105 29.4778 40.483C29.477 39.6825 29.3066 38.8909 28.9777 38.1592C28.7195 38.6612 28.3893 39.1238 27.9973 39.5327C26.8458 40.7307 25.2774 41.4609 23.6793 41.9491C21.613 42.5806 19.386 42.8476 17.2801 42.3598C16.0831 42.0862 14.9646 41.5478 14.009 40.7852C14.1953 44.2722 17.5844 47.051 21.7389 47.051Z",
    fill: "#DBA75C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9554 44.4104C23.5301 44.4104 24.8066 43.2102 24.8066 41.7296C24.8066 40.2491 23.5301 39.0488 21.9554 39.0488C20.3808 39.0488 19.1042 40.2491 19.1042 41.7296C19.1042 43.2102 20.3808 44.4104 21.9554 44.4104Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6838 43.7402C23.1085 43.7402 24.2634 42.69 24.2634 41.3945C24.2634 40.099 23.1085 39.0488 21.6838 39.0488C20.2592 39.0488 19.1042 40.099 19.1042 41.3945C19.1042 42.69 20.2592 43.7402 21.6838 43.7402Z",
    fill: "#574120"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3262 40.6574C20.9261 40.6574 21.4124 40.1773 21.4124 39.5851C21.4124 38.9928 20.9261 38.5127 20.3262 38.5127C19.7263 38.5127 19.24 38.9928 19.24 39.5851C19.24 40.1773 19.7263 40.6574 20.3262 40.6574Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.529 39.9162C25.7287 39.9162 26.7012 38.956 26.7012 37.7716C26.7012 36.5871 25.7287 35.627 24.529 35.627C23.3292 35.627 22.3567 36.5871 22.3567 37.7716C22.3567 38.956 23.3292 39.9162 24.529 39.9162Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9605 49.5934C86.4595 49.5934 90.1066 46.0837 90.1066 41.7542C90.1066 37.4248 86.4595 33.915 81.9605 33.915C77.4616 33.915 73.8145 37.4248 73.8145 41.7542C73.8145 46.0837 77.4616 49.5934 81.9605 49.5934Z",
    fill: "#FFBF00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9605 48.7935C86.4595 48.7935 90.1066 45.4628 90.1066 41.3543C90.1066 37.2457 86.4595 33.915 81.9605 33.915C77.4616 33.915 73.8145 37.2457 73.8145 41.3543C73.8145 45.4628 77.4616 48.7935 81.9605 48.7935Z",
    fill: "#940006"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5533 47.0511C85.8273 47.0511 89.292 44.1105 89.292 40.4831C89.292 36.8556 85.8273 33.915 81.5533 33.915C77.2792 33.915 73.8145 36.8556 73.8145 40.4831C73.8145 44.1105 77.2792 47.0511 81.5533 47.0511Z",
    fill: "url(#paint1_radial_2_423)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M81.553 47.051C85.827 47.051 89.2919 44.1105 89.2919 40.483C89.291 39.6825 89.1207 38.8909 88.7918 38.1592C88.5336 38.6612 88.2034 39.1238 87.8113 39.5327C86.6598 40.7307 85.0915 41.4609 83.4935 41.9491C81.427 42.5806 79.2001 42.8476 77.0942 42.3598C75.8972 42.0863 74.7787 41.5479 73.8232 40.7852C74.0094 44.2722 77.3985 47.051 81.553 47.051Z",
    fill: "#DBA75C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7699 44.4104C83.3445 44.4104 84.621 43.2102 84.621 41.7296C84.621 40.2491 83.3445 39.0488 81.7699 39.0488C80.1952 39.0488 78.9187 40.2491 78.9187 41.7296C78.9187 43.2102 80.1952 44.4104 81.7699 44.4104Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4983 43.7402C82.9229 43.7402 84.0778 42.69 84.0778 41.3945C84.0778 40.099 82.9229 39.0488 81.4983 39.0488C80.0736 39.0488 78.9187 40.099 78.9187 41.3945C78.9187 42.69 80.0736 43.7402 81.4983 43.7402Z",
    fill: "#574120"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1406 40.6574C80.7405 40.6574 81.2268 40.1773 81.2268 39.5851C81.2268 38.9928 80.7405 38.5127 80.1406 38.5127C79.5407 38.5127 79.0544 38.9928 79.0544 39.5851C79.0544 40.1773 79.5407 40.6574 80.1406 40.6574Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3434 39.9162C85.5431 39.9162 86.5157 38.956 86.5157 37.7716C86.5157 36.5871 85.5431 35.627 84.3434 35.627C83.1437 35.627 82.1711 36.5871 82.1711 37.7716C82.1711 38.956 83.1437 39.9162 84.3434 39.9162Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0289 34.3541C43.5279 34.3541 47.175 30.8444 47.175 26.515C47.175 22.1855 43.5279 18.6758 39.0289 18.6758C34.5299 18.6758 30.8828 22.1855 30.8828 26.515C30.8828 30.8444 34.5299 34.3541 39.0289 34.3541Z",
    fill: "#FFBF00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0289 33.5542C43.5279 33.5542 47.175 30.2236 47.175 26.115C47.175 22.0064 43.5279 18.6758 39.0289 18.6758C34.5299 18.6758 30.8828 22.0064 30.8828 26.115C30.8828 30.2236 34.5299 33.5542 39.0289 33.5542Z",
    fill: "#940006"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6216 31.8118C42.8956 31.8118 46.3604 28.8712 46.3604 25.2438C46.3604 21.6164 42.8956 18.6758 38.6216 18.6758C34.3476 18.6758 30.8828 21.6164 30.8828 25.2438C30.8828 28.8712 34.3476 31.8118 38.6216 31.8118Z",
    fill: "url(#paint2_radial_2_423)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.6215 31.8118C42.8961 31.8118 46.3603 28.8712 46.3603 25.2438C46.3595 24.4432 46.1891 23.6517 45.8603 22.9199C45.6021 23.422 45.2718 23.8846 44.8797 24.2935C43.7282 25.4915 42.16 26.2216 40.5619 26.7099C38.4955 27.3413 36.2685 27.6083 34.1626 27.1206C32.9655 26.847 31.8471 26.3086 30.8916 25.546C31.0778 29.033 34.4668 31.8118 38.6215 31.8118Z",
    fill: "#DBA75C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8382 29.1712C40.4129 29.1712 41.6894 27.9709 41.6894 26.4904C41.6894 25.0098 40.4129 23.8096 38.8382 23.8096C37.2636 23.8096 35.9871 25.0098 35.9871 26.4904C35.9871 27.9709 37.2636 29.1712 38.8382 29.1712Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5666 28.5009C39.9913 28.5009 41.1462 27.4507 41.1462 26.1552C41.1462 24.8598 39.9913 23.8096 38.5666 23.8096C37.142 23.8096 35.9871 24.8598 35.9871 26.1552C35.9871 27.4507 37.142 28.5009 38.5666 28.5009Z",
    fill: "#574120"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2092 25.4182C37.8091 25.4182 38.2954 24.9381 38.2954 24.3458C38.2954 23.7536 37.8091 23.2734 37.2092 23.2734C36.6094 23.2734 36.123 23.7536 36.123 24.3458C36.123 24.9381 36.6094 25.4182 37.2092 25.4182Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4118 24.6769C42.6115 24.6769 43.584 23.7167 43.584 22.5323C43.584 21.3479 42.6115 20.3877 41.4118 20.3877C40.2121 20.3877 39.2395 21.3479 39.2395 22.5323C39.2395 23.7167 40.2121 24.6769 41.4118 24.6769Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.525 34.3541C71.024 34.3541 74.6711 30.8444 74.6711 26.515C74.6711 22.1855 71.024 18.6758 66.525 18.6758C62.026 18.6758 58.3789 22.1855 58.3789 26.515C58.3789 30.8444 62.026 34.3541 66.525 34.3541Z",
    fill: "#FFBF00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M66.525 33.5542C71.024 33.5542 74.6711 30.2236 74.6711 26.115C74.6711 22.0064 71.024 18.6758 66.525 18.6758C62.026 18.6758 58.3789 22.0064 58.3789 26.115C58.3789 30.2236 62.026 33.5542 66.525 33.5542Z",
    fill: "#940006"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1177 31.8118C70.3917 31.8118 73.8565 28.8712 73.8565 25.2438C73.8565 21.6164 70.3917 18.6758 66.1177 18.6758C61.8437 18.6758 58.3789 21.6164 58.3789 25.2438C58.3789 28.8712 61.8437 31.8118 66.1177 31.8118Z",
    fill: "url(#paint3_radial_2_423)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.1175 31.8118C70.3915 31.8118 73.8564 28.8712 73.8564 25.2438C73.8555 24.4432 73.6852 23.6517 73.3563 22.9199C73.0981 23.4219 72.7679 23.8846 72.3758 24.2935C71.2243 25.4915 69.6561 26.2216 68.058 26.7099C65.9916 27.3413 63.7646 27.6083 61.6586 27.1206C60.4616 26.847 59.3432 26.3086 58.3877 25.546C58.5738 29.033 61.9629 31.8118 66.1175 31.8118Z",
    fill: "#DBA75C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3343 29.1712C67.909 29.1712 69.1855 27.9709 69.1855 26.4904C69.1855 25.0098 67.909 23.8096 66.3343 23.8096C64.7597 23.8096 63.4832 25.0098 63.4832 26.4904C63.4832 27.9709 64.7597 29.1712 66.3343 29.1712Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0627 28.5009C67.4874 28.5009 68.6423 27.4507 68.6423 26.1552C68.6423 24.8598 67.4874 23.8096 66.0627 23.8096C64.6381 23.8096 63.4832 24.8598 63.4832 26.1552C63.4832 27.4507 64.6381 28.5009 66.0627 28.5009Z",
    fill: "#574120"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7051 25.4182C65.305 25.4182 65.7913 24.9381 65.7913 24.3458C65.7913 23.7536 65.305 23.2734 64.7051 23.2734C64.1052 23.2734 63.6189 23.7536 63.6189 24.3458C63.6189 24.9381 64.1052 25.4182 64.7051 25.4182Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9079 24.6769C70.1076 24.6769 71.0801 23.7167 71.0801 22.5323C71.0801 21.3479 70.1076 20.3877 68.9079 20.3877C67.7082 20.3877 66.7356 21.3479 66.7356 22.5323C66.7356 23.7167 67.7082 24.6769 68.9079 24.6769Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8699 98.873C29.8699 98.873 19.5343 99.1823 23.6059 103.511C27.6774 107.84 43.6507 101.347 43.6507 101.347L29.8699 98.873Z",
    fill: "url(#paint4_radial_2_423)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8395 98.873C76.8395 98.873 87.1752 99.1823 83.1035 103.511C79.0318 107.84 63.0588 101.347 63.0588 101.347L76.8395 98.873Z",
    fill: "url(#paint5_radial_2_423)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4799 72.0069C84.0943 79.0557 88.4527 90.2808 82.2863 96.949C75.7655 104.001 61.526 103.149 53.0057 103.149C44.4854 103.149 30.2459 104.001 23.7251 96.949C17.5587 90.2809 21.9171 79.0559 24.5315 72.0069C28.6131 61.0019 37.4501 35.6213 53.0057 35.6211C68.5613 35.6209 77.3983 61.0021 81.4799 72.0069Z",
    fill: "url(#paint6_radial_2_423)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4323 54.9588C69.497 45.0839 62.5039 35.6209 53.0057 35.6211C37.4501 35.6211 28.6132 61.0019 24.5315 72.0069C22.2639 78.121 18.6891 87.3748 21.803 94.0737C21.4651 91.6764 21.518 89.2411 21.9594 86.8602C23.4902 78.7374 34.7792 38.1232 51.2343 37.1786C60.0618 36.672 68.5026 46.0594 74.4323 54.9588Z",
    fill: "#FFBF00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1643 49.0898C40.1643 49.0898 51.2616 57.0578 64.7128 49.0898C64.7128 49.0898 49.2439 53.0738 40.1643 49.0898Z",
    fill: "#940006"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9721 50.645C42.9721 50.645 42.7716 45.596 43.674 45.2C44.5765 44.804 48.688 45.992 48.688 45.992L47.0801 51.9702L42.9721 50.645Z",
    fill: "#FFDEF8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8183 50.5555C61.8183 50.5555 62.0207 45.4612 61.1182 45.0652C60.2157 44.6692 56.1042 45.8572 56.1042 45.8572L57.8089 51.9954L61.8183 50.5555Z",
    fill: "#FFDEF8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.4125 100.154C33.1803 100.285 33.9518 100.4 34.7274 100.489C41.9559 101.316 49.6161 100.229 56.7301 98.892C63.3415 97.6495 70.0335 95.8959 76.1297 93.0298C79.3895 91.4973 82.7809 89.5956 85.4061 87.1047C85.1833 81.8168 83.0275 76.1811 81.4797 72.0077C81.2668 71.4338 81.0393 70.8165 80.8002 70.1699C75.2577 79.0652 65.1075 85.3631 55.4322 88.9493C48.3079 91.5899 40.662 93.1274 33.0311 92.7752C29.3809 92.5888 25.7665 91.9714 22.2651 90.936C21.7801 90.795 21.2727 90.6418 20.7549 90.4741C20.9996 92.1499 21.5185 93.7439 22.4021 95.191C22.4023 95.1908 26.2229 98.1795 32.4125 100.154Z",
    fill: "#940006"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3401 72.6562C24.3401 72.6562 43.0215 86.1946 45.0089 81.6818C46.9963 77.169 29.9045 65.2422 27.9168 66.6163C25.9292 67.9905 23.7439 71.2828 24.3401 72.6562Z",
    fill: "url(#paint7_radial_2_423)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9162 66.6163C25.9474 67.9768 23.7858 71.2201 24.3251 72.616C25.1027 71.3571 26.149 70.2807 27.3911 69.4618C28.352 68.8323 29.4883 68.3546 30.6324 68.4939C31.5549 68.6061 32.3769 69.1033 33.1603 69.5968C37.6782 72.4431 42.2552 75.8737 44.0639 80.8544C44.2401 81.3291 44.3722 81.8185 44.4589 82.3167C44.7042 82.1664 44.8962 81.9445 45.0082 81.6817C46.9957 77.1689 29.9036 65.2427 27.9162 66.6163Z",
    fill: "#FFBF00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3879 72.1348C81.3879 72.1348 62.7065 85.673 60.7191 81.1602C58.7316 76.6474 75.8235 64.7213 77.8112 66.0948C79.7988 67.4682 81.984 70.7612 81.3879 72.1348Z",
    fill: "url(#paint8_radial_2_423)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8111 66.0948C79.7799 67.4553 81.9415 70.6988 81.4022 72.0945C80.6245 70.8356 79.5783 69.7592 78.3362 68.9404C77.3753 68.3109 76.239 67.8331 75.0949 67.9725C74.1724 68.0847 73.3505 68.5819 72.5671 69.0754C68.049 71.9216 63.4721 75.3522 61.6634 80.3331C61.4872 80.8077 61.3551 81.2972 61.2684 81.7954C61.0231 81.6451 60.8311 81.4231 60.719 81.1604C58.7317 76.6474 75.8237 64.7213 77.8111 66.0948Z",
    fill: "#FFBF00"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M151.455 98.873C151.455 98.873 141.12 99.1823 145.191 103.511C149.263 107.84 165.236 101.347 165.236 101.347L151.455 98.873Z",
    fill: "url(#paint9_radial_2_423)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M198.425 98.873C198.425 98.873 208.761 99.1823 204.689 103.511C200.617 107.84 184.644 101.347 184.644 101.347L198.425 98.873Z",
    fill: "url(#paint10_radial_2_423)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M152.028 64.9927L151.214 63.8561C149.417 62.8571 147.475 62.1345 145.457 61.7131C143.865 61.3811 142.142 61.2537 140.669 61.9362C138.555 62.916 137.487 65.349 137.356 67.6509C137.298 68.6686 137.393 69.7182 137.834 70.64C138.777 72.6124 141.026 73.5635 143.088 74.348L148.281 76.3244C148.48 76.4001 148.699 76.4766 148.901 76.41C149.025 76.3603 149.135 76.2806 149.221 76.1781C149.856 75.5005 150.115 74.5691 150.354 73.6763L151.466 69.52L151.295 66.5292C151.294 66.5995 152.028 64.9225 152.028 64.9927Z",
    fill: "url(#paint11_radial_2_423)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M196.64 64.9927L197.453 63.8561C199.251 62.8571 201.192 62.1345 203.211 61.7131C204.802 61.3811 206.526 61.2537 207.998 61.9362C210.112 62.916 211.18 65.349 211.311 67.6509C211.37 68.6686 211.275 69.7182 210.834 70.64C209.891 72.6124 207.641 73.5635 205.58 74.348L200.387 76.3244C200.188 76.4001 199.969 76.4766 199.767 76.41C199.642 76.3603 199.532 76.2806 199.447 76.1781C198.812 75.5005 198.552 74.5691 198.314 73.6763L197.202 69.52L197.373 66.5292C197.374 66.5995 196.64 64.9225 196.64 64.9927Z",
    fill: "url(#paint12_radial_2_423)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M203.066 72.0069C205.68 79.0557 210.039 90.2808 203.872 96.949C197.351 104.001 183.112 103.149 174.592 103.149C166.071 103.149 151.832 104.001 145.311 96.949C139.145 90.2809 143.503 79.0559 146.117 72.0069C150.199 61.0019 159.036 35.6213 174.592 35.6211C190.147 35.6209 198.984 61.0021 203.066 72.0069Z",
    fill: "url(#paint13_radial_2_423)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M196.018 54.9588C191.083 45.0839 184.09 35.6209 174.592 35.6211C159.036 35.6211 150.199 61.0019 146.117 72.0069C143.85 78.121 140.275 87.3748 143.389 94.0737C143.051 91.6764 143.104 89.2411 143.545 86.8602C145.076 78.7374 156.365 38.1232 172.82 37.1786C181.647 36.672 190.088 46.0594 196.018 54.9588Z",
    fill: "#FFADEF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M174.481 58.2306C179.871 58.2306 184.241 54.0256 184.241 48.8385C184.241 43.6513 179.871 39.4463 174.481 39.4463C169.09 39.4463 164.721 43.6513 164.721 48.8385C164.721 54.0256 169.09 58.2306 174.481 58.2306Z",
    fill: "#FFC7F4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M174.481 57.2723C179.871 57.2723 184.241 53.2818 184.241 48.3593C184.241 43.4368 179.871 39.4463 174.481 39.4463C169.09 39.4463 164.721 43.4368 164.721 48.3593C164.721 53.2818 169.09 57.2723 174.481 57.2723Z",
    fill: "#87006C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M173.993 55.1846C179.113 55.1846 183.265 51.6615 183.265 47.3155C183.265 42.9694 179.113 39.4463 173.993 39.4463C168.872 39.4463 164.721 42.9694 164.721 47.3155C164.721 51.6615 168.872 55.1846 173.993 55.1846Z",
    fill: "url(#paint14_radial_2_423)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.993 55.1846C179.114 55.1846 183.265 51.6615 183.265 47.3155C183.264 46.3563 183.06 45.408 182.666 44.5312C182.356 45.1327 181.961 45.687 181.491 46.1769C180.111 47.6122 178.232 48.487 176.318 49.0721C173.842 49.8285 171.174 50.1485 168.651 49.5641C167.216 49.2364 165.876 48.5913 164.731 47.6775C164.955 51.8554 169.015 55.1846 173.993 55.1846Z",
    fill: "#DBA75C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M174.252 52.0214C176.139 52.0214 177.668 50.5834 177.668 48.8095C177.668 47.0357 176.139 45.5977 174.252 45.5977C172.365 45.5977 170.836 47.0357 170.836 48.8095C170.836 50.5834 172.365 52.0214 174.252 52.0214Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M173.927 51.2186C175.634 51.2186 177.017 49.9603 177.017 48.4081C177.017 46.8559 175.634 45.5977 173.927 45.5977C172.22 45.5977 170.836 46.8559 170.836 48.4081C170.836 49.9603 172.22 51.2186 173.927 51.2186Z",
    fill: "#574120"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M173.22 47.1487C173.728 46.647 173.728 45.8335 173.22 45.3318C172.712 44.8301 171.888 44.8301 171.38 45.3318C170.872 45.8335 170.872 46.647 171.38 47.1487C171.888 47.6504 172.712 47.6504 173.22 47.1487Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M177.335 46.6362C178.773 46.6362 179.938 45.4858 179.938 44.0666C179.938 42.6475 178.773 41.4971 177.335 41.4971C175.898 41.4971 174.732 42.6475 174.732 44.0666C174.732 45.4858 175.898 46.6362 177.335 46.6362Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M159.099 73.625C159.099 73.625 172.917 83.5468 189.666 73.625C189.666 73.625 170.405 78.586 159.099 73.625Z",
    fill: "#87006C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M162.595 75.5616C162.595 75.5616 162.345 69.2744 163.469 68.7813C164.593 68.2882 169.712 69.7674 169.712 69.7674L167.71 77.2115L162.595 75.5616Z",
    fill: "#FFDEF8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M186.063 75.4498C186.063 75.4498 186.315 69.1064 185.191 68.6133C184.067 68.1202 178.947 69.5995 178.947 69.5995L181.07 77.2427L186.063 75.4498Z",
    fill: "#FFDEF8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M153.998 100.154C154.766 100.285 155.538 100.4 156.313 100.489C163.542 101.316 171.202 100.229 178.316 98.892C184.927 97.6495 191.619 95.8959 197.716 93.0298C200.975 91.4973 204.367 89.5956 206.992 87.1047C206.769 81.8168 204.613 76.1811 203.066 72.0077C202.853 71.4338 202.625 70.8165 202.386 70.1699C196.844 79.0652 186.693 85.3631 177.018 88.9493C169.894 91.5899 162.248 93.1274 154.617 92.7752C150.967 92.5888 147.352 91.9714 143.851 90.936C143.366 90.795 142.859 90.6418 142.341 90.4741C142.585 92.1499 143.104 93.7439 143.988 95.191C143.988 95.1908 147.808 98.1795 153.998 100.154Z",
    fill: "#87006C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M170.561 37.3398C170.561 37.3398 176.224 52.8895 189.365 43.218L170.561 37.3398Z",
    fill: "#87006C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M170.561 37.3397L199.688 9.20117L189.666 44.1422C189.666 44.1422 186.22 45.3792 170.561 37.3397Z",
    fill: "#1EE2FA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M178.898 41.2769C187.512 44.9104 189.666 44.1433 189.666 44.1433L190.872 39.9365C186.935 40.7711 182.925 41.2201 178.898 41.2769Z",
    fill: "#14C5FA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M195.12 13.6158L187.986 20.5069C190.996 20.1775 193.979 19.6359 196.911 18.8863L198.718 12.5859C197.543 13.0071 196.341 13.3511 195.12 13.6158Z",
    fill: "#14C5FA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M181.161 27.0995L173.223 34.7683C179.693 35.2286 186.196 34.9424 192.599 33.9155L194.99 25.582C190.459 26.6349 185.816 27.1444 181.161 27.0995Z",
    fill: "#14C5FA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M170.561 37.3404L196.771 13.0252L189.666 44.1431L199.689 9.20215L170.561 37.3404Z",
    fill: "#9CFFFC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M203.545 0L203.831 5.25626L208.379 8.00302L203.405 9.89634L202.164 15.0158L198.803 10.9296L193.488 11.3467L196.386 6.92805L194.341 2.06655L199.494 3.42165L203.545 0Z",
    fill: "#FFD829"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M203.831 5.25594L203.557 0.232422C203.411 1.55325 203.264 2.87403 203.117 4.19478C203.055 4.75291 202.991 5.31874 202.782 5.84078C203.433 6.51111 203.993 7.26174 204.449 8.07398L201.889 8.79809C201.782 9.82664 201.493 10.8288 201.037 11.7595C200.278 10.8708 199.659 9.87333 199.204 8.80115C198.234 9.18772 197.207 9.41446 196.163 9.47231C196.781 8.70226 197.437 7.77653 197.198 6.82285C197.103 6.5135 196.962 6.21984 196.78 5.95165L194.422 2.08728L194.341 2.06578L196.385 6.9274L193.487 11.3461L198.803 10.9297L202.165 15.0158L203.405 9.89637L208.38 8.00293L203.831 5.25594Z",
    fill: "#FFB70F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0828 34.7163) scale(16.5985 16.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.876 34.7163) scale(16.5985 16.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9596 19.4771) scale(16.5985 16.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.446 19.4771) scale(16.5985 16.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-115.837 104.129) scale(21.7256 21.4173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-250.338 104.129) rotate(180) scale(21.7255 21.4173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.7711 58.7268) scale(46.7281 46.1438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-19.856 64.9133) scale(29.6729 29.2947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-376.966 64.3919) rotate(180) scale(29.6729 29.2945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-83.561 104.129) scale(21.7258 21.4173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-293.782 104.129) rotate(180) scale(21.7255 21.4173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.01 60.8437) scale(16.5078 16.2964)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-583.802 60.8437) rotate(180) scale(16.5078 16.2964)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.318 58.7268) scale(46.7281 46.1438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2_423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.372 40.4063) scale(19.8868 19.6257)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAnimal);
export default __webpack_public_path__ + "static/media/RightAnimal.9e8e9b7ebbf92e67e41c92944c88349c.svg";
export { ForwardRef as ReactComponent };